import { ITopology } from "../../app/apiSlice";
import moment from "moment";

interface IDateCreationTopology{
    topology: ITopology
}
const DataCreationTopology = ({topology}: IDateCreationTopology) => {
    return (
        <>
        <div style={{color:"#757575"}} key={topology.id}>
        Date de création : {moment(topology.creationDate).format("lll")}
        </div>
        </>
    )
}

export default DataCreationTopology;